<template>
  <div>
    <div class="system-builder__select-communication--container">
      <div class="system-builder__select-communication--item">
        <img :src="sharedState.customFields.two_way_image.url" :alt="sharedState.customFields.two_way_image.alt">
        <strong>{{sharedState.customFields.two_way_title}}</strong>
        <div v-html="sharedState.customFields.two_way_description"></div>
        <button class="button__solid--blue" @click="setSelectedCommunication('2-way')">Select</button>
      </div>

      <div class="system-builder__select-communication--item">
        <img :src="sharedState.customFields.one_way_image.url" :alt="sharedState.customFields.one_way_image.alt">
        <strong>{{sharedState.customFields.one_way_title}}</strong>
        <div v-html="sharedState.customFields.one_way_description"></div>
        <button class="button__solid--blue" @click="setSelectedCommunication('1-way')">Select</button>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router/index'

  export default {
    name: 'selectCommunicationType',
    data () {
      return {
        sharedState: store.state
      }
    },
    methods: {
      setSelectedCommunication: function (str) {
        // Save the communication type to state
        store.setSelectedCommunication(str)

        // Navigate to remote selection
        store.updateCurrentStateRoute('selectRemote')
        router.push({name: 'selectRemote'})
      }
    },
    mounted: function () {
      if (store.state.vehicleObject.year === 'Vehicle Year') {
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      } else if (store.state.selectedSystemCategory === '') {
        store.updateCurrentStateRoute('selectCommunicationType')
        router.push({name: 'selectCommunicationType'})
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectCommunicationType.vue?1d189527